export const SET_MARKET_SUCCESS = 'SET_MARKET_SUCCESS'
export type MarketFetchSuccessAction = {
  type: 'SET_MARKET_SUCCESS'
}

export type MarketAction = MarketFetchSuccessAction
